"use client";
import { Stack, styled, Typography } from "@mui/material";
import Image from "next/image";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import CallRoundedIcon from "@mui/icons-material/CallRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import Marquee from "react-fast-marquee";
import { useRouter, usePathname } from "next/navigation";

const MarqueeText = styled(Typography)`
  background: -webkit-linear-gradient(rgba(151, 4, 0, 1), rgba(141, 85, 11, 1));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export function Footer() {
  const router = useRouter();

  const menuList = [
    { title: "เกี่ยวกับเรา", route: "/about-us" },
    { title: "คุณภาพของแบรนด์", route: "/brand-quality" },
    { title: "ผลิตภัณฑ์", route: "/products" },
    { title: "เมนูแนะนำ", route: "/recommended-menus" },
    { title: "รีวิว", route: "/reviews" },
    { title: "โปรโมชั่น", route: "/promotions" },
    { title: "ข่าวสาร&กิจกรรม", route: "/news-events" },
    { title: "ติดต่อเรา", route: "/contact-us" },
  ];

  const handleNavigate = (route: string) => {
    router.push(route);
  };

  return (
    <Stack>
      <Stack
        direction={{
          xs: "column",
          md: "row",
        }}
        px={{
          xs: 4,
          md: 30,
        }}
        py={{
          xs: 10,
          md: 20,
        }}
        gap={{
          xs: 20,
          md: 30,
        }}
        justifyContent="space-between"
      >
        <Stack
          gap={10}
          maxWidth={{
            xs: "100%",
            md: "30%",
          }}
        >
          <Stack gap={2}>
            <Typography variant="body2" fontWeight={700}>
              บริษัท ปลาร้าเชฟไพรฑูรย์ ฟู้ดโปรดักส์ จำกัด
            </Typography>
            <Typography variant="caption">
              เรามุ่งมั่นพัฒนาสินค้าและบริการอย่างไม่หยุดยั้ง
              ผู้บริโภคจึงมั่นใจได้ว่า ผลิตภัณฑ์ภายใต้เครื่องหมายการค้า
              “เชฟไพรฑูรย์” มีมาตรฐาน สะอาด ปลอดภัยและถูกสุขลักษณะ
            </Typography>
          </Stack>
          <Stack gap={3}>
            <Stack direction="row" gap={1} alignItems="center">
              <LocationOnRoundedIcon sx={{ color: "#fff", fontSize: 14 }} />
              <Typography variant="caption">
                123 ม.10 บ้านทรัพย์ภูพาน ต.บ้านดง อำเภออุบลรัตน์ จังหวัดขอนแก่น
                40250
              </Typography>
            </Stack>
            <Stack direction="row" gap={1} alignItems="center">
              <CallRoundedIcon sx={{ color: "#fff", fontSize: 14 }} />
              <a href="tel:0615634452" style={{ textDecoration: "none" }}>
                <Typography variant="caption">061 563 4452</Typography>
              </a>
            </Stack>
            <Stack direction="row" gap={1} alignItems="center">
              <EmailRoundedIcon sx={{ color: "#fff", fontSize: 14 }} />
              <a
                href="mailto:plarachefpraitoonfoodproduct.co@gmail.com"
                style={{ textDecoration: "none" }}
              >
                <Typography variant="caption">
                  plarachefpraitoonfoodproduct.co@gmail.com
                </Typography>
              </a>
            </Stack>
          </Stack>
          <Stack
            display={{
              xs: "none",
              md: "flex",
            }}
          >
            <Typography fontSize={12} color="textSecondary">
              All right reserved, Plarachefpraitoon 2025
            </Typography>
          </Stack>
        </Stack>
        <Stack
          gap={3}
          display={{
            xs: "none",
            md: "flex",
          }}
        >
          {menuList.map((menu, index) => (
            <Stack
              key={`${menu}-${index}`}
              onClick={() => handleNavigate(menu.route)}
            >
              <Typography variant="caption">{menu.title}</Typography>
            </Stack>
          ))}
        </Stack>
        <Stack
          gap={3}
          display={{
            xs: "flex",
            md: "none",
          }}
          direction="row"
        >
          <Stack width="50%">
            {menuList.slice(0, 4).map((menu, index) => (
              <Stack
                key={`${menu}-${index}`}
                onClick={() => handleNavigate(menu.route)}
              >
                <Typography variant="caption">{menu.title}</Typography>
              </Stack>
            ))}
          </Stack>
          <Stack width="50%">
            {menuList.slice(4).map((menu, index) => (
              <Stack
                key={`${menu}-${index}`}
                onClick={() => handleNavigate(menu.route)}
              >
                <Typography variant="caption">{menu.title}</Typography>
              </Stack>
            ))}
          </Stack>
        </Stack>
        <Stack
          gap={{
            xs: 6,
            md: 3,
          }}
          direction={{
            xs: "row",
            md: "column",
          }}
          alignItems="center"
        >
          <Typography fontSize={12}>Follow Us</Typography>
          <Stack direction="row" gap={2}>
            <a href="https://www.facebook.com/Chefpraitoonoffice">
              <Image
                src="/images/facebook.png"
                width={32}
                height={32}
                alt="facebook logo"
              />
            </a>
            <a href="https://lin.ee/bNy1HIl">
              <Image
                src="/images/line.png"
                width={32}
                height={32}
                alt="facebook logo"
              />
            </a>
            <a href="https://www.youtube.com/@PlaraChefPraitoonOfficial">
              <Image
                src="/images/youtube.png"
                width={32}
                height={32}
                alt="facebook logo"
              />
            </a>
            <a href="https://www.tiktok.com/@plara.chefpaitoon">
              <Image
                src="/images/tiktok.png"
                width={32}
                height={32}
                alt="facebook logo"
              />
            </a>
          </Stack>
        </Stack>
      </Stack>
      <Stack
        px={4}
        py={20}
        gap={30}
        display={{
          xs: "flex",
          md: "none",
        }}
      >
        <Typography fontSize={12} color="textSecondary">
          All right reserved, Plarachefpraitoon 2025
        </Typography>
      </Stack>
      <Stack>
        <Marquee>
          <Stack
            direction="row"
            gap={30}
            alignItems="center"
            justifyContent="space-evenly"
            ml={30}
            mb={15}
          >
            <MarqueeText variant="h3" fontStyle="italic" fontWeight={200}>
              # plara chefpraitoon
            </MarqueeText>
            <MarqueeText variant="h3" fontStyle="italic" fontWeight={200}>
              # plara chefpraitoon
            </MarqueeText>
            <MarqueeText variant="h3" fontStyle="italic" fontWeight={200}>
              # plara chefpraitoon
            </MarqueeText>
          </Stack>
        </Marquee>
      </Stack>
    </Stack>
  );
}
